import axios from 'axios';
import store from '@/store';
import endpointVersion from '@/helpers/endpoint-version';
const controller = '360/profile';
/**
 * Get the Timeline data
 *
 * @param {Number} customerId
 */
export const getTimeline = async (customerId) => {
    const brand = store.getters.selectedBrand;
    const tokenV3 = store.state.auth.tokenV3;
    return axios
        .get(`${controller}/getTimeline`, {
        baseURL: endpointVersion('v3'),
        params: {
            brand: brand.id,
            pid: customerId,
        },
        headers: { Authorization: `Bearer ${tokenV3}` },
    })
        .then(data => data.data);
};
export const getCustomerInteractions = async (customerId, full = 1) => {
    const brand = store.getters.selectedBrand;
    const tokenV3 = store.state.auth.tokenV3;
    return axios({
        headers: { Authorization: `Bearer ${tokenV3}` },
        method: 'GET',
        baseURL: endpointVersion('v3'),
        url: '/360/customer/getInteractions',
        params: {
            brand: brand.id,
            customerId,
            full,
            limit: 9999,
        },
    }).then(response => response.data);
};
export const getOrderInformation = async (customerId, orderId, orderStore, orderDate) => {
    const brand = store.getters.selectedBrand;
    const tokenV3 = store.state.auth.tokenV3;
    return axios({
        headers: { Authorization: `Bearer ${tokenV3}` },
        method: 'GET',
        baseURL: endpointVersion('v3'),
        url: '/360/order/orderDetail',
        params: {
            brand: brand.id,
            pid: customerId,
            orderId,
            orderStore,
            orderDate,
        },
    }).then(data => data.data);
};
